module.exports = __webpack_public_path__ + "img/partners-4.4a39554b.png";